import React from "react";
import { Pencil, Trash2 } from "lucide-react";
import { Button } from "@/components/ui";
import { VALUE_TYPES } from "@/containers/Coach/SmartLink/ExtraParamsDialog/components/ExtraParamForm";
import { SmartLinkExtraParam } from "@/services/bedrock";

interface Props {
  onEdit?: (param: Partial<SmartLinkExtraParam>) => void;
  onDelete?: (param: Partial<SmartLinkExtraParam>) => void;
  p: Partial<SmartLinkExtraParam>;
}

export function ExtraParamCard({ p, onEdit, onDelete }: Props) {
  return (
    <div
      key={p.extraParamId || p.queryKey}
      className="flex items-center justify-between p-3 border border-slate-300 rounded-xl hover:bg-slate-50 transition-colors group shadow-sm bg-white"
    >
      <code className="text-sm font-bold text-slate-900">{p.queryKey}</code>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          {p.valueType === "STATIC" ? (
            <span className="text-xs font-semibold text-slate-500 tracking-wider">"{p.value}"</span>
          ) : (
            <div className="flex items-center gap-1.5 px-2 py-0.5 bg-indigo-50 border border-indigo-100 rounded text-primary shadow-sm">
              <span className="text-xs font-bold uppercase tracking-tight font-mono">
                {VALUE_TYPES.find(v => v.value === p.valueType)?.label}
              </span>
              <span className="text-xs font-medium italic opacity-80 whitespace-nowrap">(auto)</span>
            </div>
          )}
        </div>
        {(onEdit || onDelete) && (
          <div className="flex items-center gap-1">
            {onEdit && (
              <Button variant="ghost" size="icon-sm" onClick={() => onEdit(p)} type="button">
                <Pencil className="size-3.5" />
              </Button>
            )}
            {onDelete && (
              <Button
                variant="ghost"
                size="icon-sm"
                className="text-red-500 hover:text-red-700 hover:bg-red-50"
                onClick={() => onDelete(p)}
                type="button"
              >
                <Trash2 className="size-3.5" />
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}
